export const ITEM_ID_PREFIX = 'ITEM-';

export const stripItemIdPrefix = (value) =>
  String(value || '').replace(/^ITEM-/i, '');

export const ensureItemIdPrefix = (value) => {
  const itemId = String(value || '').trim();
  if (!itemId || /^ITEM-/i.test(itemId)) return itemId;
  return `${ITEM_ID_PREFIX}${itemId}`;
};
